export enum ExportType {
  PDF = 'pdf',
  CSV = 'csv',
  XLSX = 'xlsx',
  ZIP = 'zip',
}
